// TBD - Only placeholder until we start working on this module, paths might change
import evaluateRoutes from '@/modules/Evaluate/router';
import finetuneRoutes from '@/modules/Finetune/router';
import playgroundRoutes from '@/modules/Playground/router';
import traceRoutes from '@/modules/Traces/router';
import applicationsRoutes from '@/modules/Applications/router';
import ragRoutes from '@/modules/RAG/router';
import { memoizedGetProjects } from '@/services/project';
import { RouteNames } from '@/types/routes';
import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: 'projects',
    name: RouteNames.PROJECT_HOME,
    redirect: { name: RouteNames.PROJECTS },
    children: [
      {
        name: RouteNames.PROJECTS,
        path: '',
        components: {
          belowTopBar: () => import('./views/ListProjects.vue'),
        },
      },
      {
        path: ':projectId',
        name: RouteNames.PROJECT_SUBPAGES,
        components: {
          belowTopBar: () => import('@/layouts/ProjectBasedLayout.vue'),
        },
        beforeEnter: async (to, from, next) => {
          try {
            const projects = await memoizedGetProjects();
            const projectId = to.params.projectId;
            if (!projectId || !projects.some((project) => project.id === projectId)) {
              next({ name: RouteNames.NOTFOUND });
              return;
            }
            if (to.name === RouteNames.PROJECT_SUBPAGES) {
              next({ name: RouteNames.PLAYGROUND, params: to.params });
              return;
            }
            next();
          } catch {
            next({ name: RouteNames.NOTFOUND });
          }
        },
        children: [
          ...traceRoutes,
          ...playgroundRoutes,
          ...evaluateRoutes,
          ...ragRoutes,
          ...finetuneRoutes,
          ...applicationsRoutes,
        ],
      },
    ],
  },
];
export default routes;
